<script lang="ts">
    import Raindrop from "../../../public/icons/raindrop.svelte";
    import Thermometer from "../../../public/icons/thermometer.svelte";
    import { conditions, cType, Observation, Widget, widgetInfo, WidgetType } from "../../store";

    export let isPrimaryCondition: boolean = false;

    let fill = "--default-color"
    let errorFill = "--error-color"
    let threshold = undefined;
    let conditionValue;

    widgetInfo.subscribe((value: Widget) => {
        if (value) {
            if(value.type != WidgetType.DEF && isPrimaryCondition){
                fill = "--primary-color"
            }
            if (isPrimaryCondition && value.policies) { // NPA
                threshold = value.primaryThreshold;
            } else {
                const currentConditions = value.widgetConditions;
                const temperatureCondition = currentConditions.find(
                    condition => condition.conditionType === cType.PRECIP
                );
                if (temperatureCondition) {
                    threshold = temperatureCondition.threshold;
                }
            }
        }
    });

    conditions.subscribe((value: Observation) => {
        if(value && value.precipitation && value.precipitation != null){
            const precipValue = value.precipitation.value;
            const precipStr = precipValue.toFixed(2)
            conditionValue = parseFloat(precipStr);
            if(threshold != undefined && precipValue >= threshold)
                fill = errorFill;
        }
        else{
            conditionValue = "0";
        }
    });

</script>

<div class="cc-container" style="color: var({fill});">
    {#if !isPrimaryCondition}
      <div class="weatherIcon">
        <Raindrop fill="var({fill})"/>
      </div>
    {/if}

      <div class="{isPrimaryCondition ? "primary-value":"value"}" >{conditionValue}"</div>

    <div class="{isPrimaryCondition ? "primary-label" : "label"}">Precip</div>
      
    

  </div>
